export default __webpack_public_path__ + "static/media/ChaltenUso10.d153a269.jpeg";